<template>
  <div class="test-wrapper">
    <div class="container">
      <div class="header">
        <div class="steps">
          <div
            class="step"
            v-for="item in testQuestions"
            :key="item.id"
            :class="{ active: activeStep >= item.id }"
          ></div>
        </div>
      </div>
      <div class="content">
        <div class="question">
          <img src="@/assets/imgs/logo.png" alt="logo" />
          <div class="label">
            {{ testQuestions[activeStep - 1].question }}
          </div>
        </div>
        <div class="option-group">
          <div
            class="option"
            v-for="question in testQuestions[activeStep - 1].options"
            :key="question.value"
            @click="goNextStep(question.attribute)"
          >
            <div
              class="label"
              :style="{ width: question.style?.width || '250px' }"
              :class="{ active: currentAnswer == question.attribute }"
            >
              <span
                class="circle"
                ref="optionCircleRef"
                aria-hidden="true"
                :style="{ height: question.style?.height || '65px' }"
              >
                <span class="icon">{{ question.value }}</span>
              </span>
              <span class="button-text">{{ question.label }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <span>测测你的昆曲艺术形象</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
// import initWx from "@/utils/weixin.config";
import { FEMALE_TEST_QUESTION, MALE_TEST_QUESTION } from "@/constant/test.js";

const route = useRoute();
const router = useRouter();

const gender = ref(route.params.gender);

//当前步骤
const activeStep = ref(1);
//测试问题
const testQuestions = ref(FEMALE_TEST_QUESTION);
//测试回答
const testAnswers = ref([]);

const initQuestions = () => {
  switch (gender.value) {
    case "FEMALE":
      testQuestions.value = FEMALE_TEST_QUESTION;
      break;
    case "MALE":
      testQuestions.value = MALE_TEST_QUESTION;
      break;
    default:
      break;
  }
};

//下一步
const optionCircleRef = ref(null);
const currentAnswer = ref("");
const goNextStep = (answer) => {
  currentAnswer.value = answer;
  testAnswers.value.push(answer);
  setTimeout(() => {
    if (activeStep.value == 8) {
      window.sessionStorage.setItem(
        "kunqu_test_answer",
        JSON.stringify(testAnswers.value)
      );
      router.replace({
        name: "Result",
        params: {
          gender: gender.value,
        },
      });
    } else {
      activeStep.value++;
    }
    currentAnswer.value = "";
  }, 500);
};

let bgmAudio = null;
const playBgm = () => {
  const bgm = require("@/assets/bgms/test.mp3");
  bgmAudio = new Audio(bgm);
  bgmAudio.loop = true; // 设置循环播放
  bgmAudio.play().catch((error) => {
    console.log("自动播放受阻：", error);
  });
};

onMounted(() => {
  // initWx();
  initQuestions();
  playBgm();
});

onBeforeUnmount(() => {
  if (bgmAudio) {
    bgmAudio.pause();
    bgmAudio.currentTime = 0; // 重置播放时间
  }
});
</script>

<style lang="scss" scoped>
$header-height: 100px;
$footer-height: 100px;
.test-wrapper {
  height: 100vh;
  background-color: #ffffff;
  overflow: hidden;
  .container {
    width: 100%;
    height: 100%;
    position: relative;
    .header {
      width: 100%;
      height: $header-height;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 40px 0 0 0;
      .steps {
        display: flex;
        justify-content: space-around;
        gap: 5px;
        .step {
          width: 25px;
          height: 4px;
          border-radius: 3px;
          background-color: #e9eddf;
        }
        .active {
          background-color: #c9cfc3;
        }
      }
    }
    .content {
      width: 100%;
      height: calc(100% - $header-height - $footer-height);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      gap: 20px;
      .question {
        width: 35%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        img {
          width: 65px;
        }
        .label {
          font-size: 17px;
          color: $font-color;
          font-weight: 550;
          line-height: 28px;
          text-align: justify;
        }
      }
      .option-group {
        display: flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        .option {
          .label {
            position: relative;
            display: inline-block;
            cursor: pointer;
            outline: none;
            // border: 2px solid #c9cfc3;
            border-radius: 50px;
            vertical-align: middle;
            text-decoration: none;
            background: transparent;
            padding: 0;
            font-size: inherit;
            font-family: inherit;
            min-width: 250px;
            height: auto;
            box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
          }

          .label .circle {
            transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
            margin: 0;
            width: 65px;
            min-height: 65px;
            background: #ebe4d2;
            border-radius: 50px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .label .circle .icon {
            transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
            color: $font-color;
            position: relative;
            font-size: 20px;
            font-weight: 550;
            left: 26px;
          }

          .label .button-text {
            transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 20px 25px 20px 80px;
            color: $font-color;
            font-size: 15px;
            font-weight: 700;
            line-height: 1.6;
            text-align: left;
            text-transform: uppercase;
          }

          .label.active .circle {
            width: 100%;
          }
        }
      }
    }
    .footer {
      width: 100%;
      position: absolute;
      bottom: 0px;
      height: $footer-height;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #8c9285;
      }
    }
  }
}
.header,
.question,
.option-group {
  opacity: 0;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.header,
.question {
  animation: fadeIn 1s ease forwards 0.5s;
}
.option-group {
  animation: fadeIn 1s ease forwards 1s;
}
@media screen and (max-width: 768px) {
  .question {
    width: 75% !important;
  }
}
</style>
